import { createStore } from "vuex";
import langModule from "./modules/langModule";
//import tokenModule from "./modules/tokenModule";
import axios from "axios";
//創建一個新的store實例
export default createStore({
  namespaced: true,
  state: {
    isLoading: false
  },
  getters: {},
  actions: {
    setLoading(context, payLoad) {
      context.commit('SET_LOADING', payLoad);
    },
    // 取得 random user api
    async getUser() {
      try {
        const response = await axios.get("https://randomuser.me/api/");
        return response;
      } catch (error) {
        return await Promise.reject(error);
      }
    },
  },
  mutations: {
    SET_LOADING(state, payLoad){
      state.isLoading = payLoad;
    }
  },
  modules: {
    langModule: langModule,
   // tokenModule: tokenModule
  },
});
